// extracted by mini-css-extract-plugin
export default {"logoCont":"styles_logoCont__IVtnK","logo":"styles_logo__XJMgc"};